
import Vue from 'vue';
import { CvButton } from '@carbon/vue';
import Close16 from '@carbon/icons-vue/es/close/16';

export default Vue.extend({
  components: {
    Close16,
    CvButton,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    caption: {
      type: String,
      default: '',
    },
  },
  methods: {
    onClose: function () {
      this.$emit('sidebar:toggle');
    },
  },
});
